// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"social-share__wrapper___13HB9","toggle":"social-share__toggle___1nr5v","item":"social-share__item___B7xXo","close":"social-share__close___9EWRW","icon-share":"social-share__icon-share___2KoZC"};


//////////////////
// WEBPACK FOOTER
// ./app/components/shared/SocialShare/social-share.scss
// module id = 187
// module chunks = 0